import service from '../../utils/request'


const getVideoListByGid = (data) => {
    return service({
        url: `api/curric/getVideoListByGid?cid=${data.cid}&gid=${data.gid}&uid=${data.uid}`,
        method: 'get',
    })
}
const toLookOneVideoPag = data => {
    return service({
        url: `api/class/toLookOneVideoPag?cid=${data.cid}&gid=${data.gid}&vid=${data.vid}`,
        method: 'get',
    })
}

export {
    getVideoListByGid,
    toLookOneVideoPag
}